import { render, staticRenderFns } from "./OnlineStore.vue?vue&type=template&id=b0c0b8c8&scoped=true&"
import script from "./OnlineStore.vue?vue&type=script&lang=js&"
export * from "./OnlineStore.vue?vue&type=script&lang=js&"
import style0 from "./OnlineStore.vue?vue&type=style&index=0&id=b0c0b8c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c0b8c8",
  null
  
)

export default component.exports